import { Injectable } from '@angular/core';

import { createAction, props, Store } from '@ngrx/store';

import { IAppState } from '../states/app.state';
import { TAppType } from '../states/setting.state';

export const SET_APP_STATE = createAction('[setting] Set app state', props<{ appState: TAppType }>());

export const SIGN_UP_COMMAND = createAction('[setting] Sign up command');
export const SIGN_UP_SUCCESS = createAction('[setting] Sign up success', props<{ valid: boolean }>());

export const CHECK_USER_COMMAND = createAction('[setting] Check user command');
export const CHECK_USER_SUCCESS = createAction('[setting] Check user success');
@Injectable({
  providedIn: 'root',
})
export class SettingActionsService {
  constructor(private _store$: Store<IAppState>) {}

  setAppState(appState: TAppType) {
    this._store$.dispatch(SET_APP_STATE({ appState }));
  }

  signUp() {
    this._store$.dispatch(SIGN_UP_COMMAND());
  }

  checkUser() {
    this._store$.dispatch(CHECK_USER_COMMAND());
  }
}
